import type { AvailableWireDoc, DsSingleSelectAvailableWireDocOption } from '@/components/Views/Company/File/file.types';
import type { Branch } from '@/types/closinglock.types';

export const getWireDocLabel = (wireDoc: AvailableWireDoc, defaultWireDocId?: AvailableWireDoc['id']): string => {
    let label = wireDoc.name;
    if (!wireDoc.active) {
        label += ' (inactive)';
    }
    if (wireDoc.id === defaultWireDocId) {
        label += ' (default)';
    }
    return label;
};

export const filterWireDocsByBranch = (wireDocs: AvailableWireDoc[], branchId?: Branch['id']): AvailableWireDoc[] =>
    wireDocs.filter(wireDoc => wireDoc.branch_id === branchId);

export const buildWireDocOptions = (
    wireDocs: AvailableWireDoc[],
    branchId?: Branch['id'],
    defaultWireDocId?: AvailableWireDoc['id'],
): DsSingleSelectAvailableWireDocOption[] =>
    filterWireDocsByBranch(wireDocs, branchId).map(wireDoc => ({
        ...wireDoc,
        value: wireDoc.id,
        label: getWireDocLabel(wireDoc, defaultWireDocId),
    }));
